<template>
  <section class="modal-template">
    <div class="modal-title">
      <slot name="card-title"></slot>
    </div>
    <section class="comparison-data">
      <slot name="comparison-data">
      </slot>
    </section>
    <section class="content">
      <slot name="content">
      </slot>
    </section>
    <section class="inputs">
      <slot name="inputs">
      </slot>
    </section>
  </section>

</template>

<script>
export default {
  name: 'ModalTemplate',
};
</script>

